export enum LocalWallboxConnectionPortDefinition {
  REST = 8443,
  UDP = 7090,
}
